import React from 'react';

type FillColor = string;
type ClassName = string;

interface Props {
  fillColor: FillColor;
  className: ClassName;
}

const MicIcon = ({
  fillColor,
  className,
}: Props): React.ReactElement<React.ReactNode> => (
  <svg
    width="16"
    height="16"
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    aria-labelledby="micIcon"
  >
    <title id="micIcon">Microphone icon</title>
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M7.99996 0C9.47272 0 10.6666 1.19391 10.6666 2.66667V8C10.6666 9.47276 9.47272 10.6667 7.99996 10.6667C6.5272 10.6667 5.33329 9.47276 5.33329 8V2.66667C5.33329 1.19391 6.5272 0 7.99996 0ZM12 6.66667V8C12 10.2091 10.2091 12 7.99996 12C5.79082 12 3.99996 10.2091 3.99996 8V6.66667C3.99996 6.29848 3.70148 6 3.33329 6C2.9651 6 2.66663 6.29848 2.66663 6.66667V8C2.66663 10.7197 4.70242 12.964 7.33329 13.2921V14.6667H5.33329C4.9651 14.6667 4.66663 14.9651 4.66663 15.3333C4.66663 15.7015 4.9651 16 5.33329 16H7.99996H10.6666C11.0348 16 11.3333 15.7015 11.3333 15.3333C11.3333 14.9651 11.0348 14.6667 10.6666 14.6667H8.66663V13.2921C11.2975 12.964 13.3333 10.7197 13.3333 8V6.66667C13.3333 6.29848 13.0348 6 12.6666 6C12.2984 6 12 6.29848 12 6.66667ZM6.66663 2.66667C6.66663 1.93029 7.26358 1.33333 7.99996 1.33333C8.73634 1.33333 9.33329 1.93029 9.33329 2.66667V8C9.33329 8.73638 8.73634 9.33333 7.99996 9.33333C7.26358 9.33333 6.66663 8.73638 6.66663 8V2.66667Z"
      fill="black"
    />
    <mask
      id="mask0"
      mask-type="alpha"
      maskUnits="userSpaceOnUse"
      x="2"
      y="0"
      width="12"
      height="16"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M7.99996 0C9.47272 0 10.6666 1.19391 10.6666 2.66667V8C10.6666 9.47276 9.47272 10.6667 7.99996 10.6667C6.5272 10.6667 5.33329 9.47276 5.33329 8V2.66667C5.33329 1.19391 6.5272 0 7.99996 0ZM12 6.66667V8C12 10.2091 10.2091 12 7.99996 12C5.79082 12 3.99996 10.2091 3.99996 8V6.66667C3.99996 6.29848 3.70148 6 3.33329 6C2.9651 6 2.66663 6.29848 2.66663 6.66667V8C2.66663 10.7197 4.70242 12.964 7.33329 13.2921V14.6667H5.33329C4.9651 14.6667 4.66663 14.9651 4.66663 15.3333C4.66663 15.7015 4.9651 16 5.33329 16H7.99996H10.6666C11.0348 16 11.3333 15.7015 11.3333 15.3333C11.3333 14.9651 11.0348 14.6667 10.6666 14.6667H8.66663V13.2921C11.2975 12.964 13.3333 10.7197 13.3333 8V6.66667C13.3333 6.29848 13.0348 6 12.6666 6C12.2984 6 12 6.29848 12 6.66667ZM6.66663 2.66667C6.66663 1.93029 7.26358 1.33333 7.99996 1.33333C8.73634 1.33333 9.33329 1.93029 9.33329 2.66667V8C9.33329 8.73638 8.73634 9.33333 7.99996 9.33333C7.26358 9.33333 6.66663 8.73638 6.66663 8V2.66667Z"
        fill="white"
      />
    </mask>
    <g mask="url(#mask0)">
      <rect width="16" height="16" fill="black" />
    </g>
  </svg>
);

export { MicIcon };
